import { styled } from '@uhg-abyss/web/tools/styled';

export const Styles = styled('div', {
  '.abyss-checkbox-label': {
    marginTop: 0,
  },
});
